"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FC, PropsWithChildren, useContext } from "react";
import Icon from "../Icon";
import { CardButtonContext, getCardButtonColors } from "./utilities";
const CardButtonFooter: FC<PropsWithChildren> = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const {
    variant
  } = useContext(CardButtonContext);
  if (!children) {
    return null;
  }
  let t1;
  if ($[0] !== variant) {
    const textColor = getCardButtonColors("footer", variant);
    t1 = clsx("text-button-1 font-medium align-middle flex items-center justify-between w-full mt-3s", textColor);
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon type="RightSmallUp" className="group-hover:rotate-45 group-active:rotate-45 transition-all" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1) {
    t3 = <div className={t1}>{children}{t2}</div>;
    $[3] = children;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default CardButtonFooter;